// extracted by mini-css-extract-plugin
export var footLine = "br11-4a";
export var footTop = "br11-1a";
export var footTopAddress = "br11-5a";
export var footTopDesc = "br11-2a";
export var footTopText = "br11-3a";
export var footerM = "br11-0a";
export var footerNavItem = "br11-7a";
export var footerNavs = "br11-6a";
export var minWidthLimit = "br11--a";